import { default as businesssIiiBEiFNqMeta } from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/business.vue?macro=true";
import { default as health5VWD3IwsuwMeta } from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/health.vue?macro=true";
import { default as indexzIPJAAsiJqMeta } from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/index.vue?macro=true";
import { default as opinionuNY1s8cHxxMeta } from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/opinion.vue?macro=true";
import { default as politicslvjVUumA3QMeta } from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/politics.vue?macro=true";
import { default as us7KYYswu48FMeta } from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/us.vue?macro=true";
import { default as world0DjDJNecUgMeta } from "/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/world.vue?macro=true";
export default [
  {
    name: businesssIiiBEiFNqMeta?.name ?? "business",
    path: businesssIiiBEiFNqMeta?.path ?? "/business",
    meta: businesssIiiBEiFNqMeta || {},
    alias: businesssIiiBEiFNqMeta?.alias || [],
    redirect: businesssIiiBEiFNqMeta?.redirect || undefined,
    component: () => import("/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/business.vue").then(m => m.default || m)
  },
  {
    name: health5VWD3IwsuwMeta?.name ?? "health",
    path: health5VWD3IwsuwMeta?.path ?? "/health",
    meta: health5VWD3IwsuwMeta || {},
    alias: health5VWD3IwsuwMeta?.alias || [],
    redirect: health5VWD3IwsuwMeta?.redirect || undefined,
    component: () => import("/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/health.vue").then(m => m.default || m)
  },
  {
    name: indexzIPJAAsiJqMeta?.name ?? "index",
    path: indexzIPJAAsiJqMeta?.path ?? "/",
    meta: indexzIPJAAsiJqMeta || {},
    alias: indexzIPJAAsiJqMeta?.alias || [],
    redirect: indexzIPJAAsiJqMeta?.redirect || undefined,
    component: () => import("/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/index.vue").then(m => m.default || m)
  },
  {
    name: opinionuNY1s8cHxxMeta?.name ?? "opinion",
    path: opinionuNY1s8cHxxMeta?.path ?? "/opinion",
    meta: opinionuNY1s8cHxxMeta || {},
    alias: opinionuNY1s8cHxxMeta?.alias || [],
    redirect: opinionuNY1s8cHxxMeta?.redirect || undefined,
    component: () => import("/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/opinion.vue").then(m => m.default || m)
  },
  {
    name: politicslvjVUumA3QMeta?.name ?? "politics",
    path: politicslvjVUumA3QMeta?.path ?? "/politics",
    meta: politicslvjVUumA3QMeta || {},
    alias: politicslvjVUumA3QMeta?.alias || [],
    redirect: politicslvjVUumA3QMeta?.redirect || undefined,
    component: () => import("/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/politics.vue").then(m => m.default || m)
  },
  {
    name: us7KYYswu48FMeta?.name ?? "us",
    path: us7KYYswu48FMeta?.path ?? "/us",
    meta: us7KYYswu48FMeta || {},
    alias: us7KYYswu48FMeta?.alias || [],
    redirect: us7KYYswu48FMeta?.redirect || undefined,
    component: () => import("/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/us.vue").then(m => m.default || m)
  },
  {
    name: world0DjDJNecUgMeta?.name ?? "world",
    path: world0DjDJNecUgMeta?.path ?? "/world",
    meta: world0DjDJNecUgMeta || {},
    alias: world0DjDJNecUgMeta?.alias || [],
    redirect: world0DjDJNecUgMeta?.redirect || undefined,
    component: () => import("/Users/thorstenk/Desktop/FlashDesignory/news-site-nuxt-static/pages/world.vue").then(m => m.default || m)
  }
]